'use client';

import { createIcon } from './utils';

import type { TSVGIcon } from './interface';

export const PostIcon: TSVGIcon = createIcon({
  displayName: 'PostIcon',
  viewBox: '0 0 198.439 198.439',
  path: (
    <path d='M197.762 169.999 177.324 5.262a5.995 5.995 0 0 0-6.693-5.215L5.893 20.484a6 6 0 0 0-5.261 5.955v166a6 6 0 0 0 6 6h166a6 6 0 0 0 6-6v-14.021l13.915-1.727a6 6 0 0 0 5.215-6.692zm-177.326 16.44h-7.805V123.53l7.805 62.909zM13.882 40.181a6.04 6.04 0 0 0-.546.096l-1.183-9.536 154.915-19.22 1.18 9.509L13.882 40.181zm152.75 146.258h-52.65l52.65-6.532v6.532zm-135.26-.783L14.805 52.124c.184-.006.368-.011.554-.034l154.365-19.151 16.563 133.497-154.915 19.22z' />
  ),
});
